<template>
  <div class="freeEditorial freeEditorialParsys parsys">
    <div class="column columns12bleed columns section">
      <div class="grid-row bleed">
        <div class="col-12">
          <div class="col1-par parsys">
            <div class="richHeader section">
              <div class="grid-row bleed">
                <div class="col-12">
                  <div class="c_014">
                      <span class="c_029-1">
                        <picture class="picture-element  analytics-target">
                          <source srcset="/static/header_v2.jpg.ximg.l_full_m.smart.jpg, /static/header_v2.jpg.ximg.l_full_m.smart.jpg 2x" media="(min-width: 60.0em)">
                          <source srcset="/static/header_v2.jpg.ximg.l_full_m.smart.jpg, /static/header_v2.jpg.ximg.l_full_m.smart.jpg 2x" media="(min-width: 36.3125em)">
                          <source srcset="/static/header_v2.jpg.ximg.l_full_m.smart.jpg, /static/header_v2.jpg.ximg.l_full_m.smart.jpg 2x" media="(min-width: 1.0em)">
                          <img src="/static/header_v2.jpg.ximg.l_full_m.smart.jpg" alt="JOIN THE CLUB">
                        </picture>
                      </span>
                      <div class="wrapper">
                        <div class="heading-group">
                            <h2><span>NOVI NISSAN QASHQAI</span></h2>
                            <p><span>BI RADI VEDELI VEČ? NA PRAVEM MESTU STE!</span></p>
                        </div>
                        <div class="content">
                          <p>BODITE PRVI, KI BOSTE IZVEDELI VSE NOVOSTI O NOVEM VOZILU NISSAN QASHQAI E-POWER. IZPOLNITE SPODNJI OBRAZEC IN NAS SPREMLJAJTE TER BODITE MED PRVIMI OBVEŠČENI KDAJ BO NOVI QASHQAI PRISPEL V NISSANOVE PRODAJNE SALONE IN BO NA VOLJO ZA TESTNO VOŽNJO.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="contentZone section">
      <div class="content-zone container">
        <div class="link-zone">
          <div class="columns parsys">
            <div class="columns column section columns12">
              <div class="grid-row">
                <div class="col-centered col-6 center">
                  <div>
                    <div class="form section">
                      <div class="c_019">
                        <form novalidate="">
                          <fieldset>
                            <div class="parsys formBuilder">
                              <user></user>
                              <div class="extra-notice">
                                <p>S pošiljanjem svojih podatkov potrjujem, da želim prejemati novice o izbranem modelu Nissan, posredovanih s strani GA Adriatic d.o.o.</p>
                              </div>
                              <gdpr></gdpr>
                              <submit></submit>
                            </div>
                          </fieldset>
                        </form>
                      </div>
                    </div>
                    <div class="notice">
                      <p>*Obvezna polja</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/components/form/User'
import Submit from '@/components/form/Submit'
import Gdpr from '@/components/form/Gdpr'

export default {
  name: 'Form',
  components: {
    User,
    Submit,
    Gdpr,
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .form-centered {
    padding: 0 16%;
    @media only screen and (max-width: 480px) {
      padding: 0;
    }
  }

  .title {
    margin-top: 30px;
  }
  .c_004 h2 {
    border-bottom: 0px;
  }
  .c_004 .heading-group {
    margin-bottom: 0px;
  }
  .content-zone {
    border-top: 1px solid #c1c1c1;
    margin: 3em auto 0;
  }
  .c_029-1 .picture-element img {
    width: 100%;
  }
  h2 {
  font-family: "Nissan Bold",Verdana,Arial,sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    word-wrap: break-word;
    font-size: 1.5em;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue